'use client';

import React from 'react';
import { ToastContainer } from '@rv-life/design-system';

const ToastProvider = () => {
	return (
		<ToastContainer
			hideProgressBar
			draggable={false}
			position="bottom-right"
			containerId="rv-life-profile"
		/>
	);
};

export default ToastProvider;
